import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchAllUsers } from "../app/api/users";
import type { User } from "../types";

export function useUsers() {
  return useQuery<User[], Error>({
    queryKey: ["users"],
    queryFn: fetchAllUsers,
    staleTime: 1000,
    retry: 1,
  });
}

export function useUser(id: string) {
  const queryClient = useQueryClient();

  const cached = queryClient.getQueryData<User[]>(["users"]);
  const initial = cached?.find((u) => u.userId === id) ?? null;

  return useQuery<User | null, Error>({
    queryKey: ["user", id],
    enabled: !initial,
    initialData: initial,
    queryFn: async () => {
      const users = await fetchAllUsers();
      const u = users.find((u) => u._id === id);
      if (!u) throw new Error("User not found");
      return u;
    },
  });
}
